import React from "react";
import LazyImage from "../Shared/LazyImage";
import ReactTimeAgo from "react-time-ago";
import { getDateFromSeconds } from "../../utils/DateHelper";

const NotificationItem = ({ notification }) => {
    const body = notification?.body || {};
    return (
        <>
            <div className="flex justify-between w-full rounded-lg">
                <div className="flex w-full">
                    <LazyImage
                        src={
                            body.sender?.image ||
                            require("../../assets/images/no-avatar.png").default
                        }
                        className="table-user-img"
                        alt="UserImage"
                    />
                    <div className="w-full">
                        <p className="inline mr-1">
                            <span className="font-semibold capitalize">
                                {body.sender?.name}
                            </span>{" "}
                            {body.message?.html ? (
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: body.message?.html,
                                    }}
                                />
                            ) : (
                                `${body.message?.value || body.message}.`
                            )}
                        </p>
                        <span className="text-xxs text-secondary-color-lighter-blue">
                            {notification?.timestamp?.seconds && (
                                <ReactTimeAgo
                                    date={getDateFromSeconds(
                                        notification?.timestamp?.seconds
                                    )}
                                    timeStyle="round-minute"
                                />
                            )}
                        </span>
                    </div>
                </div>

                {/* <div
                        className="w-4 h-4 rounded-full flex justify-center items-center border cursor-pointer"
                        onClick={() => handleToggleRead(notification.id)}
                    >
                        {!body.read && (
                            <div className="w-2 h-2 rounded-full bg-primary-color-orange"></div>
                        )}
                    </div> */}
            </div>
        </>
    );
};

export default NotificationItem;
